import { render, staticRenderFns } from "./ModalTandaiDikirim.vue?vue&type=template&id=4dbd3e17&"
import script from "./ModalTandaiDikirim.vue?vue&type=script&lang=js&"
export * from "./ModalTandaiDikirim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports